import ServicesConfig from '@/config/ServicesConfig';
import Axios from 'axios';
import AppConfig from '@/config/AppConfig'
import querystring from "querystring"

export default {
	getProfileIAM(accesToken) {
		const authorization = 'Bearer ' + accesToken
		Axios.defaults.headers.common['Authorization'] = authorization
		return Axios.post(ServicesConfig.ACCOUNTS.GET_PROFILE_IAM)
	},
	createAccountIAM(account) {
		const a = 'Bearer ' + localStorage.getItem('accessToken');

		//headers: {'Content-Type' : Axios.defaults.headers.common['Authorization'], 'auth': { 'Bearer': account.token}}  } )
		Axios.defaults.headers.common['Authorization'] = a
		Axios.defaults.headers.common['Content-Type'] = 'application/json'

		return Axios.post(ServicesConfig.ACCOUNTS.CREATE_ACCOUNTIAM, JSON.stringify(account), {
			headers: {
				'Content-Type': 'application/json'
			}
		})

	},
	createRegisterToken() {
		let params = {
			grant_type: "client_credentials",
			scope: "register_user email_checker",
			client_id: "5c2cf6e58bc3d844442c8d6e",
			client_secret: "adbc521f3a7da54ed872a7193a1bb5ed92196a7ae572d89875a0535bb46660ac"
		}

		return Axios.post(ServicesConfig.SESSION.GENERATE_TOKEN, querystring.stringify(params), {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		});
	},
	checkEmailRegister(tokenEmailCheck, email) {
		let params = {
			email: email.toLowerCase()
		}
		const authorization = 'Bearer ' + tokenEmailCheck
		Axios.defaults.headers.common['Authorization'] = authorization
		Axios.defaults.headers.common['Content-Type'] = 'application/json'
		return Axios.post(ServicesConfig.ACCOUNTS.CHECK_EMAIL_REGISTER, params);
	},
	updatePasswordAccountIAM(account) {
		const a = 'Bearer ' + localStorage.getItem('accessToken')
		Axios.defaults.headers.common['Authorization'] = a
		Axios.defaults.headers.common['Content-Type'] = 'application/json'
		return Axios.post(ServicesConfig.ACCOUNTS.UPDATE_PASSWORDIAM, JSON.stringify(account), {
			headers: {
				'Content-Type': 'application/json'
			}
		})

	},
	createLoginTokenPortalWeb(userName, password) {
		let params = {
			grant_type: "password",
			client_id: "5c2cf7088bc3d844442c8d6f",
			client_secret: "9548f4882b0c8495dc86c9628fabcd53266d46f0a5f89655787ec75298b1df31",
			username: userName.toLowerCase(),
			password: password,
		}

		return Axios.post(ServicesConfig.SESSION.GENERATE_TOKEN, querystring.stringify(params), {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		});
	},
	createLoginTokenCSC(userName, password) {
		let params = {
			grant_type: "password",
			client_id: "5c2cf63a8bc3d844442c8d6c",
			client_secret: "0193a8f11455f6d36cd67524cb92fcec7faa5ba4667c841759f88a8b0411c561",
			username: userName.toLowerCase(),
			password: password,
		}

		return Axios.post(ServicesConfig.SESSION.GENERATE_TOKEN, querystring.stringify(params), {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		});
	},
	updateUserAccountIAMPortalWeb(accessToken, account) {
		var a = 'Bearer ' + accessToken;
		Axios.defaults.headers.common['Authorization'] = a

		return Axios.post(ServicesConfig.ACCOUNTS.UPDATE_ACCOUNTIAM, JSON.stringify(account), {
			headers: {
				'Content-Type': 'application/json'
			}
		})

	},
	updateScopesAccountIAM(account) {
		const a = 'Bearer ' + localStorage.getItem('accessToken')
		Axios.defaults.headers.common['Authorization'] = a
		Axios.defaults.headers.common['Content-Type'] = 'application/json'
		return Axios.post(ServicesConfig.ACCOUNTS.UPDATE_SCOPESIAM, account, {
			headers: {
				'Content-Type': 'application/json'
			}
		})
	},


	getAccounts(arg) {
		let params = {
			page: arg.page,
			size: arg.size,
			userId: arg.userId
		}
		if (arg.command && arg.value) {
			params[arg.command] = arg.value
		}
		return Axios.get(ServicesConfig.ACCOUNTS.GET_ACCOUNT, {
			params
		});
	},
	getAccountsIAM() {
		const a = 'Bearer ' + localStorage.getItem('accessToken')
		Axios.defaults.headers.common['Authorization'] = a
		return Axios.post(ServicesConfig.ACCOUNTS.GET_ACCOUNTSIAM);
	},
	createAccount(account) {
		return Axios.post(ServicesConfig.ACCOUNTS.CREATE_ACCOUNT, account)
	},
	updateAccount(account) {
		return Axios.put(ServicesConfig.ACCOUNTS.UPDATE_ACCOUNT, account)
	},
	changestates(stateuser) {
		return Axios.post(ServicesConfig.ACCOUNTS.CHANGE_STATUS, stateuser)
	},



	updateUserAccountIAM(account) {
		const a = 'Bearer ' + localStorage.getItem('accessToken')
		Axios.defaults.headers.common['Authorization'] = a
		Axios.defaults.headers.common['Content-Type'] = 'application/json'
		return Axios.post(ServicesConfig.ACCOUNTS.UPDATE_USERACCOUNTIAM, JSON.stringify(account), {
			headers: {
				'Content-Type': 'application/json'
			}
		})

	},


	updateAccountIAM(account) {
		const a = 'Bearer ' + localStorage.getItem('accessToken')
		Axios.defaults.headers.common['Authorization'] = a
		return Axios.post(ServicesConfig.ACCOUNTS.UPDATE_ACCOUNTIAM, JSON.stringify(account), {
			headers: {
				'Content-Type': 'application/json'
			}
		})

	},
	updatePasswordSiaerp(account) {

		let url = ServicesConfig.ASURAPI_SEGURIDAD.BASE_URL + '/security/token/user/' + account.Id + '/agency/24/app/SEG';
		return Axios.get(url)
			.then(res=> {
				let token = res.data;				
				if(token){
					url = ServicesConfig.VUE_APP_ASURAPI_IAM.BASE_URL + "Sincronizar/actualiza/";

					return Axios.post(url,account,{
						headers: {
							"TOKEN": token
						}
					})
				}
			})
		
	},
}